import { Size } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { ClassName } from 'types/ClassName';
import { ArrowBackIcon } from '../../../../assets/icons';
import { type ProjectPickerLayer } from '../ProjectPicker/hooks/useProjectPickerData';

export interface IProjectPickerDrillHeaderProps {
  layers: ProjectPickerLayer[];
  onBack: () => void;
  className?: ClassName;
}

function ProjectPickerDrillHeader({ layers, onBack, className }: IProjectPickerDrillHeaderProps) {
  const classes = classNames('project-picker-drill-header', 'picker-header', 'px-3', className);
  return (
    <div className={classes} style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
      <IconButton svg={ArrowBackIcon} size={Size.SMALL} onClick={onBack} className="mr-2" />
      <div style={{ minWidth: 0 }}>
        <h5 className="picker-title fw-bold ellipsis">{layers[layers.length - 1]?.title}</h5>
        <div className="f-sm fc-2">
          {layers
            .slice(0, -1)
            .map((layer) => layer.title)
            .join(' / ')}
        </div>
      </div>
    </div>
  );
}

export default ProjectPickerDrillHeader;
